import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getData } from '../Services/api';
import JoditEditor from 'jodit-react';

const ProductDetails = () => {
    const { id } = useParams();
    const [catList, setCatList] = useState([]);
    const editor = useRef(null);
    const [values, setValues] = useState({
        name: "",
        sku: "",
        price: "",
        offerPrice: "",
        categoryId: "",
        shortDescription: "",
        description: "",
        specifications: [{ key: "", value: "" }],
        variants: [{ size: "", color: "", stock: "" }],
        images: [],
        mainImage: null,
        features: [""],
        isFeatured: false,
        isBestseller: false,
        isNewArrival: false,
        isPremium: false
    })


    const fetchCategories = async () => {
        try {
            const res = await getData('/category');
            if (res.status) {
                setCatList(res.data || [])
            }
        } catch (error) {
            console.log("error fetch categroy", error)
        }
    }
    const fetchProducts = async () => {
        try {
            const res = await getData(`/products/${id}`);
            if (res.status) {
                setValues(res?.data?.product || {})
            }
        } catch (error) {
            console.log("error fetch products", error)
        }
    }

    useEffect(() => {
        fetchCategories();
        fetchProducts();
    }, []);


    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/products/product-list">Products</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">
                                        Products Details
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-question">
                                    <h2 className="mb-0">Products Details</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <h5>Products Details</h5>
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="row">
                                        <div className="col-sm-6 mb-3">
                                            <label className="form-label">Main Image (Thumbnail)</label>
                                            {values.mainImage && (
                                                <div style={{ marginTop: "10px", position: "relative", width: "120px" }}>
                                                    <img src={values.mainImage}
                                                        alt="Main Preview"
                                                        style={{
                                                            width: "120px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid #ddd"
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-sm-6 mb-3">
                                            <label htmlFor="procut_image" className="form-label">
                                                Product Image
                                            </label>
                                            <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
                                                {values.images.map((img, index) => (
                                                    <div key={index} style={{ position: "relative" }}>
                                                        <img
                                                            src={img}
                                                            alt="preview"
                                                            style={{
                                                                width: "120px",
                                                                height: "120px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                border: "1px solid #ddd"
                                                            }}
                                                        />

                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Category</label>
                                                <select className='form-select' name='categoryId' value={values.categoryId} disabled>
                                                    <option value="">Select Category</option>
                                                    {
                                                        catList?.map((cat) => {
                                                            return (
                                                                <option key={cat._id} value={cat._id}>{cat.cat_name}</option>

                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Product Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Product Name"
                                                    name='name'
                                                    value={values.name}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Product SKU</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter SKU"
                                                    name='sku'
                                                    value={values.sku}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Price</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Price"
                                                    name='price'
                                                    value={values.price}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">Offer Price</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Price"
                                                    name='offerPrice'
                                                    value={values.offerPrice}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Short Description</label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter dhort description"
                                                    name='shortDescription'
                                                    value={values.shortDescription}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Description</label>
                                                <JoditEditor
                                                    ref={editor}
                                                    value={values.description}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <h5>Specifications</h5>
                                            {values.specifications.length > 0 ? (
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Key</th>
                                                            <th>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {values.specifications.map((spec, index) => (
                                                            <tr key={index}>
                                                                <td>{spec.key}</td>
                                                                <td>{spec.value}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <p>No specifications available</p>
                                            )}
                                        </div>

                                        <div className="col-md-12 mt-3">
                                            <h5>Variants</h5>
                                            {values.variants.length > 0 ? (
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Size</th>
                                                            <th>Color</th>
                                                            <th>Stock</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {values.variants.map((variant, index) => (
                                                            <tr key={index}>
                                                                <td>{variant.size}</td>
                                                                <td>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "8px"
                                                                    }}
                                                                    >
                                                                        <div style={{
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            backgroundColor: variant.color,
                                                                            border: "1px solid #ccc",
                                                                            borderRadius: "4px"
                                                                        }}
                                                                        >
                                                                        </div>
                                                                        <span>{variant.color}</span>
                                                                    </div></td>
                                                                <td>{variant.stock}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <p>No variants available</p>
                                            )}
                                        </div>
 <div className='col-md-12'>
                                            <h5>Features</h5>

                                            {values.features.map((feature, i) => (
                                                <div className='row' key={i}>
                                                    <div className="col-md-10">
                                                        <div className="form-group">
                                                            <label className="form-label">Feature</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="e.g. 100% Cotton"
                                                                value={feature}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className='col-md-12'>
                                            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        name="isFeatured"
                                                        checked={values.isFeatured}
                                                        disabled
                                                    />
                                                    {" "}Featured
                                                </label>

                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        name="isBestseller"
                                                        checked={values.isBestseller}
                                                        disabled
                                                    />
                                                    {" "}Bestseller
                                                </label>

                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        name="isNewArrival"
                                                        checked={values.isNewArrival}
                                                        disabled
                                                    />
                                                    {" "}New Arrival
                                                </label>

                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        name="isPremium"
                                                        checked={values.isPremium}
                                                        disabled
                                                    />
                                                    {" "}Premium
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </form >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductDetails